export default __webpack_public_path__ + "static/media/default-events-listing-preview.3e00caa9.jpg";